import React from 'react'

// redux
import { connect } from 'react-redux'

// item
import NotificationItem from './includes/NotificationItem'
import SkeletonLoading from '../../Notifications__loadingSkeleton'

function CustomerMarketingEmails(props) {

    // props
    const {
        loading,
        loadingCount,

        notificationsList,

        handleNotificationClick,
        handleNotificationChange,
    } = props



    return (
        <div className="page-border-box2 mb-3 mb-md-4 customer-order-notifications">
            <div className="pbb2-inner d-flex">
                {/* text-sec */}
                <div className="text-sec media-body pe-3">
                    {/* header */}
                    <div className="app-header-wrapper heading-sm mb-2">
                        <p className="app-heading st-fw-600 text-capitalize mb-2">Customer marketing emails</p>
                        <p className="app-desc st-fs-14">
                            These emails help re-engage your customers and increase the number of loyal clients. You can customize any email to make it more personal, include necessary information, and promote your brand. You can upload and change the logo, edit the email subject, content, and layout.
                        </p>
                    </div>

                    <div className="customer-order-notifications-list">
                        {
                            loading ? (
                                <React.Fragment>
                                    {
                                        loadingCount?.map(item => (
                                            <SkeletonLoading key={item} />
                                        ))
                                    }
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {
                                        notificationsList?.length ? notificationsList?.map(item => (
                                            <NotificationItem
                                                key={item.template_id}
                                                dataItem={item}

                                                handleNotificationClick={(ev, tempId) => handleNotificationClick(ev, tempId)}
                                                handleNotificationChange={(ev, tempId) => handleNotificationChange(ev, tempId)}
                                            />
                                        )) : (
                                            <p>No notification(s) found</p>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </div>

                </div>
            </div>
        </div>
    )
}


const getDataFromStore = state => {
    return {
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(CustomerMarketingEmails)